import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export function CallToAction() {
  return (
    <div className="bg-gradient-to-b from-white to-purple-50">
      <div className="mx-auto max-w-7xl py-24 sm:px-6 sm:py-32 lg:px-8">
        <div className="relative isolate overflow-hidden bg-white/50 px-6 py-24 text-center shadow-2xl sm:rounded-3xl sm:px-16 backdrop-blur-lg ring-1 ring-purple-900/5">
          <div className="absolute inset-0 -z-10">
            <div className="absolute inset-0 bg-gradient-to-br from-purple-600 to-purple-500 opacity-90" />
          </div>

          <div className="absolute -top-20 -left-20 h-[500px] w-[500px] rounded-full bg-purple-400/30 blur-3xl"></div>
          <div className="absolute -bottom-20 -right-20 h-[500px] w-[500px] rounded-full bg-purple-500/30 blur-3xl"></div>

          <h2 className="mx-auto max-w-2xl text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Ready to transform your contracting process?
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-lg leading-8 text-white/90">
            Join thousands of successful contractors who use Bidzora to streamline
            their operations and win more contracts.
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <Link
              to="/dashboard"
              className="group relative inline-flex items-center justify-center overflow-hidden rounded-xl bg-white px-8 py-3 text-sm font-semibold text-purple-600 transition-all duration-200 hover:bg-purple-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
            >
              <span className="absolute -end-full transition-all group-hover:end-4">
                <ArrowRight className="h-5 w-5" />
              </span>
              <span className="transition-all group-hover:me-4">Get started today</span>
            </Link>
            <Link
              to="/contact"
              className="text-sm font-semibold leading-6 text-white hover:text-purple-100"
            >
              Contact sales <span aria-hidden="true">→</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}